<template>
  <div>
    <va-card class="overflow-auto">
      <vue-element-loading :active="visible" :is-full-screen="true" />

      <b-row class="pb-3">
        <b-col cols="10">
          <!-- <h5>*Select the option to filter the results</h5> -->
          <span style="font-size: 24px; font-weight: bold">ANALYSTS</span>
        </b-col>
        <b-col cols="2" class="text-right">
          <b-button
            class="px-4"
            variant="secondary"
            @click="addAnalystModal = true"
          >
            Add
          </b-button>
          <b-modal v-model="addAnalystModal" hide-footer hide-header>
            <AddAnalyst @stepper="winStepper" />
          </b-modal>
        </b-col>
      </b-row>

      <div class="flex md12 sm6 xs12 overflow-auto">
        <div class="overflow-aut0" style="overflow: auto">
          <b-table
            hover
            v-if="data.length"
            id="my-table"
            :fields="fields"
            :items="data"
            small
            borderless
            head-variant="dark"
            table-variant="light"
          >
            <template v-slot:cell(name)="data">
              <b-form-input
                style="text-align: center"
                borderless="true"
                @change="update(data.item)"
                v-model="data.item.name"
              />
            </template>
            <template v-slot:cell(sno)="data">
              <span v-if="currentPage > 1">{{
                (currentPage - 1) * perPage + data.item.sno
              }}</span>
              <span v-else>{{ data.item.sno }}</span>
            </template>
            <template v-slot:cell(_id)="data">
              <router-link
                :to="{
                  path: '/singlereportlist',
                  query: {
                    id: data.item._id,
                    type: 'analyst',
                  },
                }"
              >
                <b-button class="pr-4 pl-4" variant="success"
                  >View Reports</b-button
                >
              </router-link>
              <!-- <span class="px-2">
                 <b-button class="pr-4" variant="info"
                  >Edit Analayst</b-button
                >
              </span> -->
              <span style="padding-left: 20px !important">
                <b-button variant="danger" @click="deleteData(data.item._id)">
                  Remove Analyst
                </b-button>
              </span>
            </template>
          </b-table>
          <p v-else>No Data Found</p>
          <br />
          <b-pagination
            align="center"
            v-model="currentPage"
            :total-rows="totalData"
            :per-page="perPage"
            prev-text="Prev"
            next-text="Next"
            @change="nextPage"
            aria-controls="my-table"
          ></b-pagination>
          <br />
        </div>
      </div>
    </va-card>
  </div>
</template>

<script>
import axios from 'axios'
import AddAnalyst from './addAnalyst'
import VueElementLoading from 'vue-element-loading'
export default {
  components: {
    VueElementLoading,
    AddAnalyst,
  },
  props: ['type'],
  data () {
    return {
      uname: '',
      usertype: [],
      visible: false,
      perPage: 40,
      currentPage: 1,
      dat: [],
      addAnalystModal: false,
      fields: [
        {
          key: 'sno',
          label: 'S.No',
          tdClass: 'text-center',
          thClass: 'text-center',
        },
        {
          label: 'Name',
          key: 'name',
          sortable: false,
          thClass: ' pdngtblcol1',
          tdClass: 'pdngtblcol1',
        },

        {
          key: 'email',
          label: 'Email',
          sortable: false,
        },
        {
          key: 'phone',
          label: 'Phone',
          sortable: false,
        },
        {
          label: 'Action',
          key: '_id',
          sortable: false,
          thClass: ' cnt',
          tdClass: 'cnt',
        },
      ],
      data: [],
      totalData: '',
    }
  },

  mounted: function () {
    this.getList()
    this.userview()
  },
  computed: {
    rows () {
      return this.data.length
    },
    heading () {
      var value
      if (this.type == 'all') {
        value = 'TOTAL USERS'
      } else if (this.type == 'pending') {
        value = 'PENDING USERS'
      } else if (this.type == 'active') {
        value = 'ACTIVE USERS'
      } else if (this.type == 'reject') {
        value = 'REJECTED USERS'
      }
      console.log('val', value)
      return value
    },
  },
  watch: {
    uname: function () {
      this.getList()
    },
    type () {
      this.getList()
      this.uname = null
    },
    currentPage () {
      this.getList()
    },
  },
  methods: {
    winStepper (analystData) {
      this.addAnalystModal = analystData.addAnalystModal
      this.getList()
    },
    nextPage (ev) {
      this.currentPage = ev
      this.getList()
    },
    reset () {
      window.location.reload()
    },
    userview () {
      // this.visible = true;
      axios({
        method: 'GET',
        url: '/usertype/list',
      })
        .then((response) => {
          this.usertype = response.data.data
          // this.visible = false;
        })

        .catch((err) => {
          // this.visible = false;
          console.log(err)
        })
    },
    deleteData (val) {
      if (confirm('Are you sure?')) {
        this.visible = true
        axios({
          method: 'POST',

          headers: {
            token: localStorage.getItem('token'),
          },
          url: '/admin/delete/' + val,
        })
          .then((response) => {
            this.visible = false
            if (response.data.status) {
              this.getList()
              this.msg = response.data.msg
              this.$dlg.alert(this.msg, () => {}, { messageType: 'success' })
            } else {
              this.msg = response.data.msg
              this.$dlg.alert(this.msg, () => {}, { messageType: 'error' })
            }
          })
          .catch((err) => {
            this.visible = false
            this.errors.push(err)
            this.$dlg.alert(
              this.msg,
              () => {
                // this.$router.push("/Dashboard");
              },
              { messageType: 'error' }
            )
          })
      } else {
        this.visible = false
        // this.getList();
      }
    },
    getList () {
      var data1 = {}
      this.visible = true
      // this.currentPage=parseInt(this.currentPage,10)
      data1['page'] = this.currentPage
      data1['limit'] = this.perPage
      axios({
        method: 'POST',
        url: '/admin/list',
        headers: {
          token: localStorage.getItem('token'),
        },
        data: data1,
      })
        .then((response) => {
          // console.log(response.data.data)
          if (response.data.status === true) {
            for (var i = 0; i < response.data.data.length; i++) {
              response.data.data[i].sno = i + 1
            }
            this.data = response.data.data
            this.totalData = response.data.totalLength
            this.visible = false
          } else if (response.data.status === false) {
            this.visible = false
          }
        })
        .catch((e) => {
          console.log(e)
          this.visible = false
          this.errors.push(e)
          this.msg = 'failed'
        })
    },
    update (data) {
      this.visible = true
      axios({
        method: 'POST',
        url: '/admin/edit',
        data: {
          name: data.name,
          id: data._id,
        },
        headers: {
          token: localStorage.getItem('token'),
        },
      })
        .then((response) => {
          this.visible = false
          // this.status = response.data.status;
          this.msg = response.data.msg
          if (response.data.status) {
            this.getList()
            this.$bvToast.toast(response.data.msg, {
              title: 'status',
              autoHideDelay: 3000,
              variant: 'success',
            })
          } else {
            this.getList()

            this.$bvToast.toast(response.data.msg, {
              title: 'status',
              autoHideDelay: 3000,
              variant: 'danger',
            })
            this.$emit('stepper', {
              addAnalystModal: false,
            })
          }
        })
        .catch((e) => {
          console.log(e)
        })
    },
  },
}
</script>

<style>
</style>
